import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MenuItem } from 'react-bootstrap';
import { rgbToAlfa } from '../../../../selectors/UtilSelectors';
import { sendCustomClick } from '../../../../utils/SnowplowUtils';
import { buttonTypes } from '../../../../constants/SnowplowConst';

const TagProps = {
    filterId: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    color: PropTypes.string
};

const TagsBoxProps = {
    id: PropTypes.number,
    tags: PropTypes.arrayOf(PropTypes.shape(TagProps)),
    toggleTag: PropTypes.func.isRequired,
    clearCategoryTags: PropTypes.func,
    color: PropTypes.string
};

const TagsBox = props => {
    const { tags: tagsColl, toggleTag, clearCategoryTags, name: categoryName, color } = props;
    const tags = tagsColl
        .sort((tagsCollA, tagsCollB) => tagsCollA.id > tagsCollB.id ? 1 : -1 )
        .map((tag, i) => {
            const { isSelected, id: tagId, name } = tag;
            const props = {
                className: classnames('tag', { selected: isSelected }),
                onClick: (e) => {
                    sendCustomClick(buttonTypes.agendaFilterTag, String(tagId), e.currentTarget);
                    toggleTag(tag.categoryName, tagId);
                },
                style: isSelected ? {
                    color: color,
                    borderColor: color,
                    fontWeight: '600',
                    backgroundColor: `color-mix(in srgb, ${color} 15%, transparent)`,
                } : { borderColor: '#76778C' }
            };
            return (
                <div {...props} key={i}>
                    {name}
                </div>
            );
        });

    return (
        <Fragment>
            <div className="hidden-xs tags-box-wrapper">
                <div className="tags-box">{tags}</div>
                <div className="clearfix">
                    <div className="clear-tags custom-color color-1" onClick={() => clearCategoryTags(categoryName)}>Clear All</div>
                </div>
            </div>
            <div className="visible-xs tags-box-wrapper-mobile">
                <div>{tags}</div>
                <div>
                    <div className="clear-tags custom-color color-1" onClick={() => clearCategoryTags(categoryName)}>Clear All</div>
                </div>
            </div>
        </Fragment>
    );
};

TagsBox.propTypes = TagsBoxProps;

const TagsFilterProps = {
    type: PropTypes.string.isRequired,
    selectedCategoryId: PropTypes.number.isRequired,
    filters: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            name: PropTypes.string,
            tags: PropTypes.arrayOf(PropTypes.arrayOf(TagProps))
        }
    )),
    toggleTag: PropTypes.func.isRequired,
    selectFilterCategory: PropTypes.func.isRequired,
    clearCategoryTags: PropTypes.func.isRequired
};

const TagsFilter = props => {
    const { filters, toggleTag, selectFilterCategory, selectedCategoryId, clearCategoryTags, color } = props;
    return (
        <Fragment>
            {
                filters.map((filter, index) => {
                    const tagsBoxProps = {
                        ...filter,
                        toggleTag,
                        clearCategoryTags,
                        color
                    };
                    const isSelected = selectedCategoryId === filter.id;
                    const clsMenuItem = classnames({'custom-color color-1': isSelected});
                    const clsCategory = classnames('category', {'selected': isSelected});

                    const menuItemProps = {
                        eventKey: filter.id,
                        className: clsMenuItem,
                        onSelect: selectFilterCategory,
                        active: isSelected
                    };

                    return (
                        <div className={clsCategory} key={index}>
                            <MenuItem {...menuItemProps}>
                                <span style={isSelected ? {color} : {}}>{filter.name}</span><i className="fa icon-AgendaAtt_arrow custom-color color-1"/>
                            </MenuItem>
                            {isSelected && <TagsBox {...tagsBoxProps} /> }
                        </div>
                    );
                })
            }
        </Fragment>
    );
};

TagsFilter.propTypes = TagsFilterProps;

export default TagsFilter;
